import PermissionsAccessDetailSection from '../../../sections/AdminDashboard/Configuration/PermissionsAccessDetail';

const PermissionsAccessDetail = () => <PermissionsAccessDetailSection />;

export default PermissionsAccessDetail;
